export const iconFontAwesomeAlphabetA = (
	<i className="fa-solid fa-a"></i>
);
